import { isEmpty } from 'lodash'
import { useSelector } from 'react-redux'
import { Field, useFormikContext } from 'formik'

import Select from 'components/Select'

import { getMerchants } from 'store/Merchants/selectors'
import {
  checkMenuPrefix,
  isMobileMenu,
} from 'utils/revenueCenters/index'

const Merchant = ({
  selectedMenuServiceType,
  title,
  id,
  menuIndex,
  currentMenu,
  showValidationErrors,
}) => {
  const isActiveMobileMenu = isMobileMenu(selectedMenuServiceType)

  const isKioskOrPos = checkMenuPrefix(
    currentMenu.configurationModelName,
    ['kiosk', 'pos']
  )

  // when menu doesn't have asssigned menu model (configurationModelId === null) we check the serviceType from menu properties as legacy data, otherwise we check the serviceType from configurationModel name prefix
  const isDisplayMerchantDropdown = isEmpty(
    currentMenu?.configurationModelId
  )
    ? !isActiveMobileMenu
    : isKioskOrPos

  const merchants = useSelector(getMerchants)

  const { setFieldValue, errors } = useFormikContext()
  const error = errors?.menus?.[menuIndex]?.merchantId

  if (isDisplayMerchantDropdown) {
    return (
      <section>
        <h3 id={id} className="header-title">
          {title}
        </h3>
        <p className="description">
          A Merchant is required to accept payments on your POS or
          Kiosk menus for this Revenue Center
        </p>
        <div className="content-wrapper -flags-wrapper -padding-top-none">
          <div className="select-box">
            <Field
              component={Select}
              handleChange={(val) =>
                setFieldValue(`menus.${menuIndex}.merchantId`, val)
              }
              label="Menu Shift4 Merchant"
              name={`menus.${menuIndex}.merchantId`}
              options={merchants}
              defaultValue={currentMenu?.merchantId}
              error={error}
              showValidationErrors={showValidationErrors}
              dataCy="menuShift4Merchant"
              dataError="merchantId"
            />
            {showValidationErrors && error && (
              <div className="textbox__error-msg">{error}</div>
            )}
          </div>
        </div>
      </section>
    )
  }
  return null
}

export default Merchant
